import ProductBuy from 'components/Product/ProductBuy';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { Col, Row } from 'reactstrap';
import {
    inputsSelected,
    selectProductDetails,
    selectProductInputs,
    variationSelected,
} from 'store/reducers/productSlice';
import styled from 'styled-components/macro';
import ProductDetailPageImage from './ProductDetailPageImage';
import ProductDetailPageInfo from './ProductDetailPageInfo';
import ProductUsp from './ProductUsp';
import ProductDetailPageAccordion from './ProductDetailPageAccordion';

const ProductDetailPage = () => {
    const dispatch = useAppDispatch();
    const { product, variation, variations, loading } = useAppSelector(selectProductDetails);
    const productInputs = useAppSelector(selectProductInputs);
    const showUSPText = useAppSelector(({ shop }) => shop?.shop?.showUSPText) ?? false;

    return (
        <Row itemScope itemType="https://schema.org/Product" className="m-0">
            <ProductDetailPageImage loading={loading} />

            <Col xs="12" md="7" xl="6" className="p-0">
                <ProductDetailPageInfo />
                <ProductBuy
                    product={product}
                    variation={variation}
                    variations={variations}
                    pending={loading}
                    inputs={productInputs}
                    onVariationSelected={(v) => dispatch(variationSelected(v))}
                    onCollectionInputChange={(v) => dispatch(inputsSelected(v))}
                />
                {product?.attributes?.usp && showUSPText && (
                    <ProductUsp className="mt-3" usps={product.attributes.usp} />
                )}
                <ProductDetailPageAccordion />
            </Col>
        </Row>
    );
};

export default ProductDetailPage;
